import { SHOW_ITEMS_BY_DEFAULT } from '../../../constants/contentTypes';

/**
 * Items to display in carousel depending on configuration
 * @param {*} content
 *
 * @return {Boolean}
 */
export const contentItemsToShowInCarousel = (
  maxItems,
  contentListDisplayItems,
) => {
  let countItem = SHOW_ITEMS_BY_DEFAULT.CAROUSEL;
  if (!!contentListDisplayItems && contentListDisplayItems > 0) {
    countItem = contentListDisplayItems;
  } else if (maxItems > 0) {
    countItem = maxItems;
  }

  return countItem;
};
